import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  sectionChipText: {
    id: 'course-home.section-outline.section-item.chip.text',
    defaultMessage: 'Limited content. Upgrade for full access.',
    description: 'Message notifying user that some of the content in the section is locked',
  },
  sectionUpgradeButtonText: {
    id: 'course-home.section-outline.section-item.button.label',
    defaultMessage: 'Upgrade for full access',
    description: 'Message for button that is used to upgrade',
  },
  sequenceTooltipContent: {
    id: 'course-home.section-outline.sequence-item.tooltip.content',
    defaultMessage: '{lockedStatus, select, partial {Limited content} other {Not Available}}.\nUpgrade for full access.',
    description: 'Tooltip content dependent on the locked status of units in the sequence.',
  },
  upgradeBannerHeader: {
    id: 'course-home.section-outline.upgrade-banner.header',
    defaultMessage: 'Unlock graded assessments and assignments',
    description: 'Header message for the upgrade banner above the section outline',
  },
  upgradeBannerMessage: {
    id: 'course-home.section-outline.upgrade-banner.message',
    defaultMessage: 'Upgrade today and enjoy unlimited access to all course material.',
    description: 'Body message for the upgrade banner above the section outline',
  },
  upgradeBannerButtonLabel: {
    id: 'course-home.section-outline.upgrade-banner.button.label',
    defaultMessage: 'Upgrade now',
    description: 'Button label for the upgrade button in the upgrade banner above the section outline',
  },
});

export default messages;
